import { Button } from '../../../components/ui';
import { useT } from '../../../i18n';

/** Dải lỗi của một vùng dữ liệu, kèm nút thử lại (cùng khuôn màn Khoá API). */
export function VungLoi({ cau, onThuLai }: { cau: string; onThuLai: () => void }) {
  const { t } = useT();
  return (
    <div role="alert" className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
      <span className="min-w-0 text-sm text-danger-700">{cau}</span>
      <Button variant="outline" size="sm" onClick={onThuLai}>
        {t('chung.thuLai')}
      </Button>
    </div>
  );
}
